import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { ActionBlock } from "../TopBar/styled";
import { useCurrentProjectWithAddedLayers } from "../../../../hooks/project/useAddLayersToCurrentProject";
import { useSelectedResources } from "../../hooks/useSelectedResources";
import { ResourceInfoDc } from "../../types";

export const AddToProject: FC = () => {
  const { t } = useTranslation("catalog");
  const [selectedResources] = useSelectedResources();
  const addLayersToCurrentProject = useCurrentProjectWithAddedLayers(selectedResources as ResourceInfoDc[]);

  return <ActionBlock onClick={addLayersToCurrentProject}>{t("addToMap")}</ActionBlock>;
};
